import React, { Component } from 'react';
// import * as api from '../api'

export default class OuterEnded extends Component {
  constructor(props) {
    super (props)
    this.state = {
      isShow: false,
      awardsDom: null
    }
  }

  _handle2OhterActivities() {
    window.location.href = `https://m.jr.jd.com/vip/sign/html/index.html?id=1192&activityid=1158`
  }

  render() {
    return (
      <div className='main_info'>
        <div className="firendlyTip">
          <p>本场红包雨已结束</p>
          <p>感觉错过了1个亿</p>
        </div>
        <div className='award_info'>
          <p className='tipStr'>摇钱树即将上线</p>
          <p className='tipStr'>敬请期待</p>
        </div>
        <div className='btn yellow' onClick={this._handle2OhterActivities.bind(this)}>看看其它热门活动</div>
      </div>
    )
  }
}